var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpeedometer = function SvgSpeedometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 81"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#speedometer_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M67.81 74.25C75.328 66.978 80 56.785 80 45.5c0-22.091-17.909-40-40-40S0 23.409 0 45.5c0 11.285 4.673 21.478 12.19 28.75C19.386 67.286 29.192 63 40 63c10.807 0 20.613 4.286 27.81 11.25Z",
    clipRule: "evenodd",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.922 9.838a2.864 2.864 0 0 1 3.985 4.041L47.65 47.943c-3.229 4.19-9.413 4.567-13.127.8-3.715-3.765-3.253-9.943.98-13.115l34.419-25.79Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "speedometer_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h80v80H0z",
    transform: "translate(0 .5)"
  })))));
};
export default SvgSpeedometer;